import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  name: 'ed-divider'
})
class EdDivider extends Vue {

    /* Props */
    @Prop({ default: false }) readonly vertical: boolean;

    /* Computed */
    get dividerClass() : string {
        return this.vertical
        ? 'ed-divider__vertical'
        : 'ed-divider__horizontal';
    }
}

export default Vue.component('ed-divider', EdDivider);
